/* eslint-disable jsx-a11y/label-has-associated-control */
// eslint-disable-next-line import/no-extraneous-dependencies
import React from 'react'
import { ToggleSliderProps } from './utils/types.ts'

export default function ToggleSlider({
    name,
    type,
    val,
    onClick,
    disabled,
}: ToggleSliderProps) {
    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: '0.25rem',
                opacity: disabled ? 0.5 : 1,
            }}
        >
            <label
                htmlFor={`show-${type}-toggle`}
                style={{
                    fontWeight: 'bold',
                    lineHeight: '24px',
                    margin: 0,
                    cursor: disabled ? 'not-allowed' : 'pointer',
                }}
            >
                {name}
            </label>
            <button
                id={`show-${type}-toggle`}
                type="button"
                onClick={() => {
                    if (!disabled) {
                        onClick(!val)
                    }
                }}
                style={{
                    width: '44px',
                    height: '24px',
                    backgroundColor: val ? '#399098' : '#ccc',
                    borderRadius: '12px',
                    border: 'none',
                    cursor: disabled ? 'not-allowed' : 'pointer',
                    padding: '2px',
                    position: 'relative',
                    transition: 'background-color 0.3s',
                    display: 'flex',
                    alignItems: 'center',
                    flexShrink: 0,
                }}
            >
                <div
                    style={{
                        width: '20px',
                        height: '20px',
                        backgroundColor: 'white',
                        borderRadius: '50%',
                        transition: 'transform 0.3s',
                        transform: val ? 'translateX(20px)' : 'translateX(0px)',
                    }}
                />
            </button>
        </div>
    )
}
